import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize-css/normalize.css';
import './utils/icons.css';
import App from './components/App';
import registerServiceWorker from './utils/registerServiceWorker';

ReactDOM.render(React.createElement(App), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js